<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<div
	[shakeAnimation]="makeShake"
	class="light-container light-container--border-radius ticket-edit-container"
	[formGroup]="editForm"
>
	<div class="ticket-message-grid">
		<ticket-message [message]="''"></ticket-message>
	</div>
	<div class="ticket-edit-container__content multi-edit">
		<div class="ticket-edit-container__header">
			<div class="ticket-edit-container__header-thumbnail--multi-edit">
				<multi-edit-thumbnail [typeCounts]="data.typeCounts" [currentType]="data.selectedType">
				</multi-edit-thumbnail>
			</div>
			<div class="multi-edit__masthead">
				<multi-edit-masthead
					[currentType]="data.selectedType"
					[typeCounts]="data.typeCounts"
					[totalTickets]="data.originalList.size"
				>
				</multi-edit-masthead>
			</div>
			<!-- <div class="ticket-edit-icons-container">
				<ticket-icons [promiseStack]="data.data.livePromisePeriodStack" [ticketType]="data.selectedType"></ticket-icons>
			</div> -->
			<div class="ticket-edit-container__hamburger-menu">
				<ticket-action-menu [editTicketCombined]="data"></ticket-action-menu>
			</div>
		</div>

		<multi-wrapper
			(onClear)="clearInput('roleId')"
			[metadataValue]="data.keyMetadata.get('roleId')"
			[disableClear]="true"
			[multipleValuesLabel]="appStrings.GENERAL_MULTIPLE_ROLES"
			class="grid-ticket-subcomponent-wrapper ticket-edit-container__role multi-edit--location dropdown-set-width"
		>
			<ticket-role
				class="grid-ticket-subcomponent-wrapper__input"
				formControlName="roleId"
				automationId="roleId"
				[roleList]="planState.rolesApi.data.list$"
				[allowNullSelection]="false"
				[projectMember]="projectMember$ | async"
			>
			</ticket-role>
		</multi-wrapper>

		<multi-wrapper
			(onClear)="clearInput('locationId')"
			[metadataValue]="data.keyMetadata.get('locationId')"
			[disableClear]="true"
			[multipleValuesLabel]="appStrings.GENERAL_MULTIPLE_LOCATIONS"
			class="grid-ticket-subcomponent-wrapper ticket-edit-container__location multi-edit--location dropdown-set-width"
		>
			<ticket-location
				class="grid-ticket-subcomponent-wrapper__input"
				formControlName="locationId"
				automationId="locationId"
				[locationList]="planState.locationsApi.data.list$"
			>
			</ticket-location>
		</multi-wrapper>
		<multi-wrapper
			(onClear)="clearInput('activityName')"
			[metadataValue]="data.keyMetadata.get('activityName')"
			[disableClear]="true"
			class="multi-edit--description grid-ticket-subcomponent-wrapper"
			[multipleValuesLabel]="appStrings.GENERAL_MULTIPLE_DESCRIPTIONS"
		>
			<ticket-description
				class="grid-ticket-subcomponent-wrapper__input ticket-description-fixed-height--multi-edit-milestone"
				[shouldFocus]="data.ticketJustAdded"
				formControlName="activityName"
			></ticket-description>
		</multi-wrapper>
		<multi-wrapper
			(onClear)="clearInput('milestoneType')"
			[metadataValue]="data.keyMetadata.get('milestoneType')"
			class="grid-ticket-subcomponent-wrapper multi-edit-container__milestone-type dropdown-set-width"
			[multipleValuesLabel]="appStrings.GENERAL_MULTIPLE_MILESTONE_TYPE"
		>
			<div class="grid-ticket-subcomponent-wrapper__input">
				<ticket-milestone-type formControlName="milestoneType"></ticket-milestone-type>
			</div>
		</multi-wrapper>
		<multi-wrapper
			*ngIf="isAdmin$ | async"
			(onClear)="clearInput('externalScheduleId')"
			[metadataValue]="data.keyMetadata.get('externalScheduleId')"
			class="multi-edit--esid grid-ticket-subcomponent-wrapper"
			[multipleValuesLabel]="appStrings.TICKET_EDIT_MULTIPLE_EXTERNAL_SCHEDULE_ID"
		>
			<ticket-ext-sched-id
				class="grid-ticket-subcomponent-wrapper__input"
				formControlName="externalScheduleId"
			>
			</ticket-ext-sched-id>
		</multi-wrapper>
		<multi-wrapper
			*ngIf="(isAdmin$ | async) && (isWbsCodeEnabled$ | async)"
			(onClear)="clearInput('wbsCode')"
			[metadataValue]="data.keyMetadata.get('wbsCode')"
			class="multi-edit--wbs-code grid-ticket-subcomponent-wrapper"
			[multipleValuesLabel]="appStrings.TICKET_EDIT_MULTIPLE_WBS_CODE_LABEL"
		>
			<ticket-wbs-code
				class="grid-ticket-subcomponent-wrapper__input"
				formControlName="wbsCode"
			></ticket-wbs-code>
		</multi-wrapper>
	</div>
	<ticket-footer
		[showMoreDetailsButton]="false"
		[showActualizedToggle]="false"
		[actualPhase]="data.data.actualPhase"
		[isReadOnly]="(planAccess$ | async) === PlanAccessLevel.archived"
		[formDirty]="editForm.dirty"
		[formValid]="isFormValid"
		[isPlanRegion]="data.ticketsInPlanRegion"
		(onActualChange)="updateActualPhase($event)"
		(canceled)="ticketEditService.closeEdit()"
		(saved)="save()"
	>
	</ticket-footer>
</div>
